/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'townsquare.townsquare-tags.tag': '移除標記',
  'townsquare.townsquare-tags.tooltip-usage-count': '{usageCount, plural, other {已在 {usageCount,number} 地方使用}}',
};
